import Backbone from 'backbone';
import Handlebars from '../lib/handlebars';
import $ from 'jquery';
import _ from 'underscore';
import Epoxy from 'backbone.epoxy';

import i18n from '../i18n';
import Config from '../config'; 
import Field from '../model/refbooks/field';
import Model from '../model/model';
import Trigger from '../utils/trigger';
import cfBinders from './binders/cf';

import { fmt, parseYYYYMMDD, unixts } from '../utils/date';
import { constants } from '../lib/handlebars.helpers';
import { promisify } from '../utils/promisify'; 
import { accumulate, flatify, hashify, keyset } from '../utils/arrays';
import { requestBegins, requestEnds } from '../loader';
import { restore, clear } from '../ui/messages'; 





let partialsRegistered = false; 

let View = Backbone.Epoxy.View.extend( {
    
    initialize(options) {
        options = options || {};

        this.template = options.template || this.template;
        this.tpl_ = options.tpl;
        this.messages = [];
        this.rendered = false;
        this.holds = {};

        if (options.style)
            this.el.style = options.style;
        
        this.nests = options.nests || this.nests || {};
        this.ds = options.ds || this.ds || {};
        if (options.onBind)
            this.onBind = options.onBind;
        if (options.onUnBind)
            this.onUnBind = options.onUnBind;
        if (options.serialize)
            this.serialize = options.serialize;
        if (options.focus)
            this.focus = options.focus;
        if (options.open)
            this.open = options.open;
        if (options.afterRender)
            this.afterRender = options.afterRender;

        this.renderCount_ = 0;
        this.lastRendering_ = Promise.resolve();

        // todo: bug here
        this.options = options;
        const parentView = this.options[constants.PARENT_VIEW];
        const injectedName = this.options[constants.INJECTED_NAME];

        if (parentView)
            this.listenTo( this, 'all', (event, ...args) =>
                event.split( ' ' ).forEach( eventName => {
                    if (eventName[0] === ':')
                        return parentView.trigger( eventName, ...args );

                    if (eventName[0].toUpperCase() === eventName[0])
                        return parentView.trigger( eventName, ...args );
        
                    if (injectedName)
                        parentView.trigger( `${injectedName}:${eventName}`, ...args );
                } ) );

        // *** automatic event handler binding *** 
        // based on props [View.event( 'event:name1 event:name2 ...' )]
        // of view

        const iterate = hash => {
            const result = [];
            for (let key in hash) result.push( key );
            return result;
        };

        const gatherEvents = (eventHolder) => accumulate( flatify( 
            iterate( eventHolder )
                .map( potentialEventName => potentialEventName.split( /[ ;]/ )
                    .map( peName => peName.trim() )
                    .filter( peName => peName.startsWith( ':' ) )
                    .map( peName => peName.substring( 1 ) )
                    .map( peName => [peName, eventHolder[potentialEventName]] ) ) ) );

        const eventsInThis = gatherEvents( this );
        const eventsInOptions = gatherEvents( options );

        keyset( eventsInThis, eventsInOptions )
            .map( evName => [
                evName,
                // options' priority is higher
                eventsInOptions[evName] || eventsInThis[evName]
            ] )
            .forEach( ([evName, handlers]) =>
                this.listenTo( this, evName,
                    (...args) => handlers.forEach( fn => fn.call( this, ...args ) ) ) );

        // *** end of automatic event handler binding ***

        Backbone.Epoxy.View.prototype.initialize.call( this, options );
    },

    events: {

        'click [data-click-trigger]'(e) {
            const holds = this.holds[e.currentTarget.dataset.clickTrigger];
            if (!holds)
                return;

            e.stopPropagation();

            const [eventName, ...args] = holds;
            this.trigger( eventName, ...args, e );
        }

    },

    bindingFilters: {
        
        is(value, ...values) {
            return values.some( possible => value === possible );
        },

        isnt(value, ...values) {
            return values.every( possible => value !== possible );
        },

        has(value) {
            return undefined !== value;
        },

        absent(value) {
            return undefined === value;
        },

        some(...values) {
            return values.some( value => value !== undefined && value !== null );
        },

        not(value) {
            switch(value) {
                case 't': return 'f';
                case 'f': return 't';
                case true: return false;
                case false: return true;
                default: return !value;
            }
        },

        arrayProp: {

            get(array, keyName, keyValue, propName) {
                const index = array.findIndex( el => el[keyName] == keyValue );
                if (index === -1 || !array[index])
                    return [undefined, meta];

                const meta = { index, propName, array };

                return [array[index][propName], meta];
            },

            set([value, meta]) {
                const { index, propName, array } = meta;
                const result = [...array];
                return result[index][propName] = value, result;
            }

        },

        prepareCf: {

            // from model to binder
            get(fields, id, field_id, translit, format, default_value, min_count, table_id, multiselect, amountEditable, propName, path, index, attachments) {
                translit = Field.decodeString( translit );

                const meta = { 
                    id, 
                    fields: fields || {}, 
                    field_id: +field_id, 
                    translit, format, default_value,
                    min_count: +min_count, 
                    table_id: +table_id, 
                    multiselect, amountEditable, propName,
                    index,
                };
                if (path)
                    meta.path = path.split( '|' )
                        .map( str => str.split( '=' ) )
                        .map( ([parentId, parentTranslit, index, minCount]) => 
                            [+parentId, 
                                Field.decodeString( parentTranslit ),
                                +index, +minCount] )
                        .reduce( (result, arr) => [...result, ...arr], [] );
                else
                    meta.path = [];

                const [nest, is_new] = godown( meta.fields, meta.path, !id );

                const value = nest[translit] && 'value' in nest[translit]
                    ? (nest[translit].value !== '' ? nest[translit].value : null)
                    : (format === 'composite' || format === 'file' ? [] : undefined); 

                const label = nest[translit] && 'label' in nest[translit]
                    ? nest[translit].label[Config.locale()]
                    : undefined;

                if (format !== 'dataTableObjects')
                    if (value === undefined) {
                        if (!is_new)
                            return [null, label, meta];
                            
                        if (typeof default_value !== 'string')
                            return [null, label, meta];

                        const parsed = Base64.decode( default_value );
                        if (parsed === 'null')
                            return [null, label, meta];
                        else if (parsed === '')
                            return [null, label, meta];
                        else if (parsed === 'true')
                            return [true, label, meta];
                        else if (parsed === 'false')
                            return [false, label, meta];
                        else 
                            return [parsed, label, meta];
                    } else
                        return [value, label, meta];

                if (!value)
                    return [null, label, meta];
                    
                if (value.values && value.values.length && value.table_id == table_id)
                    return multiselect === 't' // todo 't'/true
                        ? [value.values, label, meta]
                        : [propName ? value.values[0][propName] : value.values[0], label, meta];
                else
                    return [null, label, meta];
            },

            // from binder to model
            set([value, label, meta]) {
                const { format, fields, field_id, translit, table_id, multiselect, propName, path } = meta;

                const [nest] = godown( fields, path );
                const result = nest && nest[translit] 
                    ? { ...nest[translit] } 
                    : { field_id };

                if (result.value != null && typeof result.value === 'object')
                    result.value = { ...result.value };

                if (result.value && result.value.values)
                    if (result.value.values instanceof Array)
                        result.value.values = result.value.values
                            .map( item => item != null && typeof item === 'object'
                                ? { ...item }
                                : item );

                if (format === 'dataTableObjects')
                    if (propName)
                        if (result.value && result.value.values && result.value.values[0]) {
                            result.value.values[0][propName] = value;
                            if (!multiselect || multiselect === 'f')
                                result.value.values.splice( 1, result.value.values.length - 1 );
                        } else 
                            // impossible case, do nothing
                            ;
                            // result.value = {
                            //     table_id,
                            //     values: [{
                            //         [propName]: value
                            //     }]
                            // };
                    else
                        if (value == null)
                            result.value = null;
                        else if (value instanceof Array) {
                            const prev = hashify( result.value && result.value.values || [], 
                                item => [item.object_id, item] );
                            result.value = {
                                table_id,
                                values: value
                                    .map( item => [item, prev[item.object_id]] )
                                    .map( ([item, prev]) => ({
                                        object_id: +item.object_id,
                                        // preserve title from old objects
                                        title: prev 
                                            ? prev.title : item.name,
                                        // preserve num from old objects if not set
                                        num: prev 
                                            ? item.num !== undefined ? item.num : prev.num
                                            : item.num || null
                                    }) )
                            };
                        } else
                            result.value = {
                                table_id,
                                values: [{
                                    // hack, better to just pass value here itself
                                    object_id: value.id,
                                    title: value.title,
                                    num: null
                                }]
                            };
                else
                    if (propName)
                        if (result.value == null || typeof result.value != 'object')
                            result.value = { [propName]: value };
                        else
                            result.value[propName] = value;
                    else
                        if (value == null)
                            result.value = null
                        else
                            result.value = value;
            
                const finalize = (json, [id, translit, index, minCount, ...rest]) => {
                    if (!translit)
                        return {
                            ...json,
                            [meta.translit]: result
                        };

                    const label = json[translit] && json[translit].label;
                    // clone instances array
                    const instances = [...json[translit] && json[translit].value || []];
                    // and add required amount of instances
                    while (instances.length < Math.max( index + 1, minCount ))
                        instances.push( {} );

                    // recursively proceed target instance and replace one with result of proceeding
                    instances[index] = finalize( instances[index] || {}, rest );

                    const node = {
                        field_id: id,
                        value: instances
                    };

                    if (label)
                        node.label = label;

                    return {
                        ...json,
                        [translit]: node
                    };
                };

                return {
                    fields: finalize( fields, path )
                };
            }

        },

    },
    
    bindingHandlers: {

        tfCheckbox: {
            set($el, value) {
                $el[0].checked = 't' === value;
            },
            
            get($el, value, event) {
                return $el[0].checked ? 't' : 'f';
            }
        },

        trueFalseCheckbox: {
            set($el, value) {
                $el[0].checked = 'true' === value || true === value;
            },
            
            get($el, value, event) {
                return $el[0].checked;
            }
        },

        float: {

            set($el, value) {
                if (!(value instanceof Array))
                    $el.val( value != undefined ? value : '' );
                else
                    $el.val( value[0] != undefined ? value[0] : '' );
            },

            get($el, prevValue/*, event */) {
                const parsed = parseFloat( $el.val() );
                const value = parsed || parsed == 0
                    ? parsed
                    : null;

                if (!(prevValue instanceof Array))
                    return value;

                const [prev, label, meta] = prevValue;
                return [value, label, meta];
            }

        },

        readonly($el, value) {
            if (!(value instanceof Array))
                $el.prop( 'readonly', !value );
            else
                $el.prop( 'readonly', !value[0] );
        },

        date: {

            set($element, timestamp) {
                $element.val( timestamp ? fmt( timestamp, 'YYYY-MM-DD' ) : '' );
            },
        
            get($element) {
                if (!$element.val())
                    return null;

                const date = parseYYYYMMDD( $element.val() );
                if (!date)
                    return date;

                return date.setHours( 0 ), date.setMinutes( 0 ), date.setSeconds( 0 ),
                    unixts( date );
            }

        },

        days: {
            set($el, value) {
                if (!value)
                    return $el.val( '' );

                $el.val( value / 86400 | 0 );
            },
            
            get($el, value, event) {
                const 
                    newDays = +$el.val() || 0,
                    oldDays = value / 86400 | 0,
                    oldHours = (value - oldDays * 86400) / 3600 | 0,
                    oldMinutes = (value - oldDays * 86400 - oldHours * 3600) / 60 | 0,
                    oldSeconds = (value - oldDays * 86400 - oldHours * 3600 - oldMinutes * 60) || 0;

                const newValue = newDays * 86400 + oldHours * 3600 + oldMinutes * 60 + oldSeconds;
                if (newValue < 0)
                    return $el.val( 0 ), null;
                
                return newValue || null;
            }
        },

        hours: {
            set($el, value) {
                if (!value)
                    return $el.val( '' );

                const 
                    oldDays = value / 86400 | 0,
                    oldHours = (value - oldDays * 86400) / 3600 | 0;

                $el.val( oldHours );
            },
            
            get($el, value, event) {
                const 
                    newHours = +$el.val() || 0,
                    oldDays = value / 86400 | 0,
                    oldHours = (value - oldDays * 86400) / 3600 | 0,
                    oldMinutes = (value - oldDays * 86400 - oldHours * 3600) / 60 | 0,
                    oldSeconds = (value - oldDays * 86400 - oldHours * 3600 - oldMinutes * 60) || 0;

                const newValue = oldDays * 86400 + newHours * 3600 + oldMinutes * 60 + oldSeconds;
                if (newValue < 0)
                    return $el.val( 0 ), null;
                
                return newValue || null;
            }
        },

        minutes: {
            set($el, value) {
                if (!value)
                    return $el.val( '' );

                const 
                    oldDays = value / 86400 | 0,
                    oldHours = (value - oldDays * 86400) / 3600 | 0,
                    oldMinutes = (value - oldDays * 86400 - oldHours * 3600) / 60 | 0;

                $el.val( oldMinutes );
            },
            
            get($el, value, event) {
                const 
                    newMinutes = +$el.val() || 0,
                    oldDays = value / 86400 | 0,
                    oldHours = (value - oldDays * 86400) / 3600 | 0,
                    oldMinutes = (value - oldDays * 86400 - oldHours * 3600) / 60 | 0,
                    oldSeconds = (value - oldDays * 86400 - oldHours * 3600 - oldMinutes * 60) || 0;

                const newValue = oldDays * 86400 + oldHours * 3600 + newMinutes * 60 + oldSeconds;
                if (newValue < 0)
                    return $el.val( 0 ), null;
                
                return newValue || null;
            }
        },

        metaString: {

            set: cfBinders.setMetaString,

            get: cfBinders.getMetaString,

        },

        metaBool: {

            set: cfBinders.setMetaBool,

            get: cfBinders.getMetaBool,

        },

        metaNumber: {

            set: cfBinders.setMetaString,

            get: cfBinders.getMetaNumber,

        },

        metaDate: {

            set: cfBinders.setMetaDate,

            get: cfBinders.getMetaDate,

        },

        metaDateOnlyString: {

            set: cfBinders.setMetaDate,

            get: cfBinders.getMetaDateOnlyString,

        },

        metaTime: {

            set: cfBinders.setMetaTime,

            get: cfBinders.getMetaTime,

        },

        metaDataTableObjects: {

            set: cfBinders.setMetaDataTableObjects

        },

        metaFile: {

            set: cfBinders.setMetaFile,

        },

    },
    
    tpl() {
        if (this.tpl_) return this.tpl_;

        if (!partialsRegistered) {
            registerPartials( global.partials, [] );
            partialsRegistered = true;
        }

        if (!this.template)
            this.template = 'jst/default.view';

        const template = this.template.replace( 'jst/', '' ).replaceAll( '/', '.' )
            .split( '.' )
            .reduce( (root, here) => root[here], global );
        
        if (!template)
            return Promise.reject( this.template );

        return this.tpl_ = Promise.resolve( Handlebars.template( template ) );
    },
    
    html(context, meta) {
        return Promise.all( [this.tpl(), i18n] )
            .then( ([templateFn]) => {
                const passedPartialBlockHelper = this.options[constants.PASSED_PARTIAL_BLOCK_HELPER];

                const options = { data: { 
                    options: this.options,
                    not: constants.NOT,
                    or: constants.OR, 
                    and: constants.AND,
                    eq: constants.EQ,
                    eqq: constants.EQQ,
                    less: constants.LESS,
                    more: constants.MORE,
                    t: constants.T,
                    f: constants.F,
                    begin: constants.BEGIN,
                    end: constants.END,
                    currentUser: {
                        role: Config.role(),
                        name: Config.user(),
                        id: +Config.userId()
                    },
                    currentOrganization: Config.organization(),
                    chiefAdmin: 8 === +Config.role(),
                    chiefInspector: 12 === +Config.role(),
                    adminOfOrg: 'ORG_ADMINISTRATOR' === Config.roleCode(),
                    inspectorOfOrg: 11 === +Config.role(),
                    adminOfCluster: 5 === +Config.role(),
                    inspectorOfCluster: 4 === +Config.role(),
                    orgUser: 'ORG_USER' === Config.roleCode(),
                    clusters: Config.clusters(),
                    orgs: Config.orgs(),
                    timezones: Config.timezones(),
                    model: this.model,
                    privs: hashify( Config.privileges() ),
                    subject: {
                        role: {
                            level: Config.level(),
                        }
                    },
                    [constants.BODY_INJECTOR]: this.options[constants.BODY_INJECTOR],
                    [constants.PARENT_VIEW]: this,
                    // if View is inside partial, and body is passed to this partial;
                    // define data-level helper to invoke this body
                    // !!! and pass this View's Handlebars "options" as last arg !!!
                    // (body is passed via View helper, see "makeViewHelper()")
                    ___bodycall___: passedPartialBlockHelper
                        ? function(options) {
                            return new Handlebars.SafeString( passedPartialBlockHelper( this, options ) );
                        }
                        : undefined,
                    meta,
                } };

                if (context.capabilities)
                    options.data.caps = context.capabilities;

                const html = templateFn( context, options );

                return html;
            } );
    },
    
    serialize() {},
    
    render(contextBase, onFinalize, meta = { views: {} }) {
        if (!onFinalize)
            onFinalize = new Trigger().fire().onFire;

        const finalizeSubviews = new Trigger();
        meta.finalizeSubviews = finalizeSubviews.onFire;

        const renderCount = ++this.renderCount_,
            lastRendering = this.afterRendering();

        // save focused element in order
        // to restore focus later        
        const [focused] = this.$( ':focus' );
        if (focused)
            focused.dataset.cursorPosition = focused.selectionStart;
        
        requestBegins();
        
        this.undelegateEvents();

        const parentContext = promisify( contextBase || {} )
            .then( context => Object.create( context ) );


        const localContext = this.serialize.toString().match( /^function\s?\(\)/ )
            ? promisify( this.serialize() )
            : parentContext.then( context => promisify( this.serialize( context ) ) );

        const contextify = Promise.all( [parentContext, localContext] )
            .then( ([parentContext, localContext]) => {
                if (localContext === parentContext)
                    localContext = {};

                if (localContext === undefined)
                    localContext = {};

                return _.extend( parentContext, localContext );
            } ) 
            .then( context => this.lastContext = context ); 

        const htmlify = contextify
            .then( context => this.html( context, meta ) );

        const subviewsRendering = htmlify.then( () => {
            // must be after htmlify done
            const embeddedViewsImporting = Object.keys( meta.views )
                .map( id => meta.views[id] );

            const embeddedViewsRendering = embeddedViewsImporting
                .map( importing => importing.then( ({rendering}) => rendering ) );
            const embeddedViewsPreparing = embeddedViewsImporting
                .map( importing => importing.then( ({prepared}) => prepared ) );

            const nestedViewsRendering = this.subviews( subview => 
                subview.render( contextify, finalizeSubviews.onFire, meta ) );
            const nestedViewsPreparing = nestedViewsRendering
                .map( rendering => rendering.prepared );

            const renderingArray = [...embeddedViewsRendering, ...nestedViewsRendering];
            const preparingArray = [...embeddedViewsPreparing, ...nestedViewsPreparing];

            const rendering = Promise.all( renderingArray );
            const prepared = Promise.all( preparingArray );

            return { rendering, prepared, };
        } );

        const subviewsRendered = subviewsRendering.then( ({rendering}) => rendering );
        const subviewsPrepared = subviewsRendering.then( ({prepared}) => prepared );

        const rendering = this.lastRendering_ = Promise.all( [htmlify, subviewsPrepared] )
            // queue renders, ignore previous errors
            .then( () => lastRendering )
            .then( embeddedViewsLoading => Promise.all( [contextify, htmlify, ...Object.keys( meta.views ).map( id => meta.views[id] )] ) )
            .then( ([context, html, ...views]) => onFinalize( () => {
                // interrupt current rendering
                if (renderCount !== this.renderCount_)
                    throw new Error( 'rendering cancelled' );

                if (this.rendered) this.detachSubviews();
                this.performRender( html, context, !this.rendered );
                if (this.model) this.applyBindings();
                this.attachSubviews();
                views.forEach( ({id, view}) => 
                    this.$el.find( `#${id}` ).replaceWith( view.el ) );

                finalizeSubviews.fire();
            } ) )
            .then( () => subviewsRendered )
            .then( () => contextify )
            .then( context => this.afterRender( context, !this.rendered ) )
            .then( () => this );

        rendering.then( requestEnds, requestEnds );
        rendering.then( () => {
            this.delegateEvents();
            restore( this );
            if (focused) this.restoreFocus( focused );
            this.rendered = true;
            this.trigger( 'render' );
        } );

        rendering.catch( ex => {
            if (String( ex ) !== 'Error: rendering cancelled')
                console.error( ex, this.el );
            else
                console.log( String( ex ), this.el );
                finalizeSubviews.cancel( ex );
        } );
            
        return rendering.view = this,
            rendering.prepared = Promise.all( [htmlify, subviewsPrepared] ), 
            rendering;
    },

    afterRendering() {
        return this.lastRendering_.catch( () => {} );
    },

    afterSuccesfulRendering() {
        return this.lastRendering_;
    },

    performRender(bodyString, context, firstTime, meta) {
        this.$el.html( bodyString );
    },
    
    afterRender() {},
    
    bind(model, render = () => this.render()) {
        if (!!model)
            if (!(model instanceof Model))
                model = new Model( model );
                
        // bind recursively
        recBind( this );
        onBindDone( this );
        // messages
        clear( this );

        const rendering = render();
        const binding = rendering.then( () => this );
        return binding.view = this,
            binding.prepared = rendering.prepared,
            binding;

        function recBind(view) {
            view.previousModel = view.model;

            if (view.model && model !== view.model)
                view.stopListening( view.model );

            if (model && model !== view.model)
                view.originalModel = model.clone();
            else if (!model) 
                view.originalModel = undefined;

            view.model = model;

            view.subviews( recBind );
            //embeddedViews( view, recBind );
        }

        function onBindDone(view) {
            if (view.previousModel)
                view.onUnBind( view.previousModel );
            if (model)
                view.onBind( model, view.previousModel );

            view.subviews( onBindDone );
            //embeddedViews( view, onBindDone );
        }
    },

    unbind(render = () => this.render()) {
        return this.bind( undefined, render );
    },

    onBind(model) {},
    
    onUnBind() {},

    final() {
        return this.subviews().length === 0;
    },

    subviews(callback) {
        return Object.keys( this.nests ).map( selector => {
            const subview = this.subview( selector );
            if ('function' === typeof callback)
                return callback.call( null, subview, selector );
                
            return subview;
        } );
    },

    subview(nestSelector) {
        let subview = this.nests[nestSelector];
        if ('function' === typeof subview)
            this.nests[nestSelector] = subview = new subview();
        if ('string' === typeof subview)
            this.nests[nestSelector] = subview = new View( { template: subview } );

        return subview;
    },
    
    detachSubviews() {
        this.subviews().forEach( view => 
            view.$el.detach() );
        embeddedViews( this, embeddedView =>
            embeddedView.$el.detach() );
    },
    
    attachSubviews() {
        this.subviews( (view, selector) => 
            this.$( selector ).append( view.$el ) );
    },
    
    remove() {
        if (this.rendered)
            this.subviews().forEach( view => view.remove() );
        Backbone.Epoxy.View.prototype.remove.call( this );
    },
    
    focus() {
        this.$el.find( 'input, select, textarea' )
            .filter( ':visible:enabled' )
            .eq( 0 )
            .focus(); 

        return this;
    },
    
    restoreFocus(focused) {
        const [el] = focused.id
            ? this.$( `#${focused.id}` )
            : this.$( `[data-id="${focused.dataset.id}"]` );
        if (!el) return;

        const len = $( el ).val().length;
        const pos = +focused.dataset.cursorPosition || len;

        el.selectionStart = pos;
        el.selectionEnd = pos;
            
        // Set cursor on focus
        el.focus();            
    },
    
    enable(on = true, options = { restoreFocus: false }) {
        // treat the case enable( {options} )
        if ('object' === typeof on) {
            options = on;
            on = true;
        }
        
        if (!on && !this.disabled) {
            this.$focused = this.$el.find( ':focus' );
        }

        const $forms = this.$el.is( 'fieldset' )
            ? this.$el
            : this.$el.add( this.$( 'fieldset' ) )
        enableEl( $forms, on );
            
        if (on) {
            if (this.$focused && options.restoreFocus)
                this.$focused.focus();
            
            this.$focused = null;
        }
        
        return this;
    },
    
    disable(on = true) {
        return this.enable( !on );
    },

    disabled() {
        return this.$el.hasClass( 'disabled' ) ||
            this.$el.attr( 'disabled' ) ||
            this.$el.closest( '.disabled' ).length > 0 ||
            this.$el.closest( '[disabled]' ).length > 0;
    },

}, {

    extend(props = {}, statics = {}) {
        const {
            bindingHandlers = {},
            bindingFilters = {},
            events = {},
            ...otherProps
        } = props;

        const newEvents = _.extend( {},
            this.prototype.events );

        const newProps = { 
            events: newEvents,
            ...otherProps 
        };

        newProps.bindingHandlers = _.extend( {}, 
            this.prototype.bindingHandlers, 
            bindingHandlers );

        newProps.bindingFilters = _.extend( {}, 
            this.prototype.bindingFilters, 
            bindingFilters );

        // split event defs like "click .link; keydown .input"
        // to events "click .link" and "keydown .input"
        for (let eventDescList in events)
            for (let eventDesc of eventDescList.split( ';' ))
                newProps.events[eventDesc.trim()] = function(e) {
                    const { holds } = e.currentTarget.dataset;

                    const args = holds 
                        ? this.holds[holds]
                        : [];

                    events[eventDescList].apply( this,
                        [e, ...args] );              
                };

        return Backbone.Epoxy.View.extend.call( this, newProps, statics );
    },

    fromTemplate(template) {
        const Class = this;
        return new Class( { template } );
    },

    event(name) {
        return name.split( ' ' )
            .map( name => `:${name.trim()}` )
            .join( ' ' );
    },

} );

export default View;

function registerPartials(root, path) {
    if ('compiler' in root)
        return Handlebars.registerPartial( path.join( '/' ), 
            Handlebars.template( root ) ); 

    for (let part in root) if (root.hasOwnProperty( part )) {
        path.push( part );
        registerPartials( root[part], path );
        path.pop();
    }
}

function embeddedViews(view, callback) {
    Object.keys( view )
        .filter( key => key[0].toUpperCase() === key[0] )
        .filter( key => view[key] instanceof View )
        .map( key => view[key] )
        .forEach( callback );
}

function enableEl($el, enable) {
    if (!enable) return disableEl( $el, true );

    $el.each( (index, el) => {
        const prevCount = +el.dataset.disabledCount || 0;
        const count = Math.max( 0, prevCount - 1 );
    
        el.dataset.disabledCount = count;
        if (count <= 1)
            $( el ).removeAttr( 'disabled' ).removeClass( 'disabled' );
    } );
}

function disableEl($el, disable) {
    if (!disable) return enableEl( $el, true );

    $el.each( (index, el) => {
        const prevCount = +el.dataset.disabledCount || 0;
        const count = prevCount + 1;
    
        if (count > 0)
            $( el ).attr( 'disabled', true ).addClass( 'disabled' );
    } );
}

function godown(fields, path, is_new) {
    while (path.length) {
        const [parentId, parentTranslit, instanceIndex, minCount, ...rest] = path;
        if (!fields)
            fields = {};
        else if (!fields[parentTranslit])
            fields = {};
        else if (!fields[parentTranslit].value)
            fields = {};
        else if (!fields[parentTranslit].value[instanceIndex])
            fields = {};
        else
            fields = fields[parentTranslit].value[instanceIndex];
        //fields = fields && fields[parentTranslit] && fields[parentTranslit].value && fields[parentTranslit].value[instanceIndex] || {};
        if (!fields.guid)
            is_new = true;
        path = rest;
    }

    return [fields, is_new];
}


// WEBPACK FOOTER //
// ./src/js/view/view.js